import { CpClaimDetailInterface, DocumentInterface } from '../../../../interfaces/dto/claim/claim-detail/cp-claim-detail-interface';

export class CpClaimDetailModel implements CpClaimDetailInterface {
  BuildingName: string = '';
  CardNumber: string = '';
  ClaimStatus: string = '';
  ClaimType: string = '';
  ClinicCase: string = '';
  DateOfTreatment: string = '';
  DoctorName: string = '';
  Documents: DocumentInterface[] = new Array<DocumentInterface>();
  IsProcessStateAditionalInformation: boolean = false;
  OccurrenceTime: string = '';
  PersonName: string = '';
  ProcessStatus: string = '';
  ProcessStatusDescription: string = '';
  ServiceName: string = '';
  ServiceType: string = '';
  SpecialtyName: string = '';
  StatusDescription: string = '';
  SubServiceName: string = '';
  TotalCoPayment?: number;

  constructor(init?: Partial<CpClaimDetailModel>) {
    Object.assign(this, init);
  }
}
